import { Injectable } from "@angular/core";

@Injectable({providedIn:'root'})
export class PhoneNumDisplayService{
    showLatestFourDigits(phNum:string):string{
        return phNum.replace(/[+\d](?=(?:\D*\d){4})/g, '*');
    }
}